module.exports = __webpack_public_path__ + "img/us.c6f63129.svg";